// extracted by mini-css-extract-plugin
export default {"classCard":"Teacher_classCard__Mt566","title":"Teacher_title__hG5cH","inputerror":"Teacher_inputerror__CHHCe","container":"Teacher_container__qRQeE","page":"Teacher_page__VqTCn"};